import ContentContainer from "layout/Content/ContentContainer";
import ProfileDetail from "pages/Profile/ProfileDetail";
import Alert from "components/ui/Alert/Alert";
import { useAccount } from "context/AccountContext";
import useEntity from "hooks/useEntity";
import Loader from "components/ui/Loader/Loader";
import { ReactComponent as IconDelete } from "assets/images/icons/delete.svg";
import Button from "components/ui/Button/Button";
import ProfileDelete from "pages/Profile/ProfileDelete";
import { useDialog } from "context/DialogContext";

function MyProfile() {
  const { user, profile, setProfile } = useAccount();
  const { entity, isLoading } = useEntity(user.profile.id, 'profile');
  const { showDialog } = useDialog();

  if (entity !== profile) {
    setProfile(entity);
  }

  if (!isLoading && !entity) {
    return <Alert message={ 'Het profiel is niet beschikbaar of er ging iets mis bij het ophalen. Probeer het later opnieuw.' }/>
  }

  const confirmDeleteUser = () => {
    showDialog(<ProfileDelete id={ user.id }/>);
  }

  return (
    <>
      <ContentContainer containerPadding={ true } contentBackground={ true }>
        { isLoading ? <Loader/> : <ProfileDetail data={ entity } isOwnProfile={ true }/> }
        <div className="wrapper--fluid">
          <div className="user-controls">
            <Button onClick={ confirmDeleteUser } className={ 'button button--ghost' }>
              <IconDelete/>
              Profiel verwijderen
            </Button>
          </div>
        </div>
      </ContentContainer>
    </>
  )
}

export default MyProfile;
